/*
 * @创建文件时间: 2019-12-10 11:09:32
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2020-07-14 15:26:08
 * @联系Qq:1638245306
 * @文件介绍: 路况评定
 */
export default [{
        path: 'mqiCellDivision',
        name: 'mqiCellDivision',
        meta: {
            title: '单元划分',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/mqiCellDivision')
    }, {
        path: 'celldivision',
        name: 'celldivision',
        meta: {
            title: '路面病害汇总',
            auth: true
        },
        component: () =>
            import ('@/views/echarts/roadDc/celldivision')
    }, {
        path: 'mqiWeightMaintenance',
        name: 'mqiWeightMaintenance',
        meta: {
            title: '评定权重及病害库',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/mqiWeightMaintenance')
    }, {
        path: 'mqiTestBatch',
        name: 'mqiTestBatch',
        meta: {
            title: '检测批次管理',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/testData/mqiTestBatch')
    }, {
        path: 'mqiPavementDisease',
        name: 'mqiPavementDisease',
        meta: {
            title: '路面病害',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/testData/mqiPavementDisease')
    }, {
        path: 'asphaltDisease',
        name: 'asphaltDisease',
        meta: {
            title: '沥青路面病害',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/testData/pavementDistress/asphaltDisease')
    }, {
        path: 'cementDisease',
        name: 'cementDisease',
        meta: {
            title: '水泥路面病害',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/testData/pavementDistress/cementDisease')
    }, {
        path: 'dinasDisease',
        name: 'dinasDisease',
        meta: {
            title: '砂石路面病害',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/testData/pavementDistress/dinasDisease')
    }, {
        path: 'mqiPavementRut',
        name: 'mqiPavementRut',
        meta: {
            title: '路面车辙',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/testData/otherPavement/mqiPavementRut')
    }, {
        path: 'mqiPavementAbrasion',
        name: 'mqiPavementAbrasion',
        meta: {
            title: '路面磨耗',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/testData/otherPavement/mqiPavementAbrasion')
    },
    {
        path: 'mqiRoadSkidResistance',
        name: 'mqiRoadSkidResistance',
        meta: {
            title: '路面抗滑',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/testData/otherPavement/mqiRoadSkidResistance')
    }, {
        path: 'mqiRoadTrip',
        name: 'mqiRoadTrip',
        meta: {
            title: '路面跳车',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/testData/otherPavement/mqiRoadTrip')
    }, {
        path: 'mqiPavementDeflection',
        name: 'mqiPavementDeflection',
        meta: {
            title: '路面结构强度-弯沉检测',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/testData/otherPavement/mqiPavementDeflection')
    }, {
        path: 'mqiSurfaceEvenness',
        name: 'mqiSurfaceEvenness',
        meta: {
            title: '路面平整度',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/testData/otherPavement/mqiSurfaceEvenness')
    }, {
        path: 'mqiRoadsideFacilities',
        name: 'mqiRoadsideFacilities',
        meta: {
            title: '沿线设施',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/testData/otherPavement/mqiRoadsideFacilities')
    }, {
        path: 'mqiStructure',
        name: 'mqiStructure',
        meta: {
            title: '桥隧构造物',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/testData/otherPavement/mqiStructure')
    }, {
        path: 'mqiRoadbed',
        name: 'mqiRoadbed',
        meta: {
            title: '路基',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/testData/otherPavement/mqiRoadbed')
    }, {
        path: 'mqiAssessManagement',
        name: 'mqiAssessManagement',
        meta: {
            title: '评定管理',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/trafficAssess/mqiAssessManagement')
    }, {
        path: 'mqiRouteAssess',
        name: 'mqiRouteAssess',
        meta: {
            title: '路线评定',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/trafficAssess/mqiRouteAssess')
    }, {
        path: 'mqiNationalAssess',
        name: 'mqiNationalAssess',
        meta: {
            title: '国检评定',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/trafficAssess/mqiNationalAssess')
    }, {
        path: 'mqiRoadNetworkAssess',
        name: 'mqiRoadNetworkAssess',
        meta: {
            title: '路网评定',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/trafficAssess/mqiRoadNetworkAssess')
    }, {
        path: 'mqiBridgeAssess',
        name: 'mqiBridgeAssess',
        meta: {
            title: '桥梁评定',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/trafficAssess/mqiBridgeAssess')
    }, {
        path: 'mqiTunnelAssess',
        name: 'mqiTunnelAssess',
        meta: {
            title: '隧道评定',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/trafficAssess/mqiTunnelAssess')
    }, {
        path: 'earlyWarningMode',
        name: 'earlyWarningMode',
        meta: {
            title: '预警模式',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/trafficAssess/earlyWarningMode')
    }, {
        path: 'technicalStatusWarning',
        name: 'technicalStatusWarning',
        meta: {
            title: '技术状况预警',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/trafficAssess/technicalStatusWarning')
    }, {
        path: 'trafficAssessSummary',
        name: 'trafficAssessSummary',
        meta: {
            title: '路况评定汇总',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/trafficAssess/trafficAssessSummary')
    },
    {
        path: 'roadDiseaseDevelopmentTrend',
        name: 'roadDiseaseDevelopmentTrend',
        meta: {
            title: '路面病害发展趋势',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/trafficAssess/publicDiseaseDevelopmentTrend')
    },
    {
        path: 'bridgeDiseaseDevelopmentTrend',
        name: 'bridgeDiseaseDevelopmentTrend',
        meta: {
            title: '桥梁病害发展趋势',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/trafficAssess/bridgeDiseaseDevelopmentTrend')
    },
    {
        path: 'tunnelDiseaseDevelopmentTrend',
        name: 'tunnelDiseaseDevelopmentTrend',
        meta: {
            title: '隧道病害发展趋势',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/trafficAssess/tunnelDiseaseDevelopmentTrend')
    },
    {
        path: 'culvertDiseaseDevelopmentTrend',
        name: 'culvertDiseaseDevelopmentTrend',
        meta: {
            title: '涵洞病害发展趋势',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/trafficAssess/culvertDiseaseDevelopmentTrend')
    },
    {
        path: 'sideSlopeDiseaseDevelopmentTrend',
        name: 'sideSlopeDiseaseDevelopmentTrend',
        meta: {
            title: '边坡病害发展趋势',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/trafficAssess/sideSlopeDiseaseDevelopmentTrend')
    },
    {
        path: 'roadMaintenanceQuality',
        name: 'roadMaintenanceQuality', //路面技术状况评价子系统-养护质量
        meta: {
            title: '养护质量',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/trafficAssess/roadMaintenanceQuality')
    },
    {
        path: 'conserveFundAnalyze',
        name: 'conserveFundAnalyze', //养护资金分析和投资决策子系统
        meta: {
            title: '养护资金分析及投资决策',
            auth: true
        },
        component: () =>
            import ('@/views/mqi/trafficAssess/conserveFundAnalyze')
    },
]